import { render, staticRenderFns } from "./techos_report.vue?vue&type=template&id=622a81b4&"
import script from "./techos_report.vue?vue&type=script&lang=ts&"
export * from "./techos_report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports